import { createApp } from 'vue'
import App from './App.vue'
import "./assets/css/index.css";
import "./assets/css/font.css";
import './assets/css/global.scss';
import router from './router';
import 'ant-design-vue/dist/reset.css';
import { Carousel ,Button,Row,Col,Form,Input,Checkbox,Modal,Spin,Select} from "ant-design-vue";

const app = createApp(App);
app.use(Carousel).use(Button).use(Row).use(Col).use(Form).use(Input).use(Checkbox).use(Modal).use(Spin).use(Select)
app.use(router).mount('#app')
